<template>
    <div id="app">
        <main-header nowtab="creator"></main-header>
        <main class="adjuster">
            <Title>作者后台 - {{ title }}</Title>
            <div v-if="tower">
                <a :href="`/tower?name=${ tower.name }`" target="_blank">评论区</a> |
                <a href="/up2cos" target="_blank">自助更新</a>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import Title from '@/components/Title'
import { createFormData, getSSRdata } from '../../utils/utils'
import axios from 'axios'

export default {
    data: () => ({
        title: '',
        tower: null,
    }),
    async created() {
        const { code, tower, endingList, difficultyList } = getSSRdata('backstage');
        if (code == -1) {
            // 
        }
        this.title = tower.title;
        this.tower = tower;
    },
    methods: {
        /**
         * @param {string}raw
         */
        parse(raw, space = true) {
            if (!space)
                raw = raw.replace(/ /, "&nbsp;");
            return raw
                .replace(/\n<br>/g, "<br>")
                .replace(/[\n\r]/g, "<br>");
        },
        async loadTowerInfo() {
            this.loading = true;
            try {
                const { data } = await axios.get("/backend/creator/towerList.php");
                this.list = data.list;
            } catch (e) {
                this.$message.error(`获取塔信息失败: ${ e }`);
            } finally {
                this.loading = false;
            }
        },
        openUploadDialog() {
            // this.uploadVisible = true;
            this.$info({
                title: '咕咕',
                content: h => (<span class="message">这个部分尚未完工，请加入发塔群发塔</span>),
            });
        },
        handleFileChange(info) {
            switch(info.file.status) {
                case "remove":
                    this.uploadForm.file = false;
                    break;
                default: 
                    this.uploadForm.file = true;
            }
            this.fileList = info.fileList;
        },
        upload() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.form.file = this.fileList[0].originFileObj;
                    this.uploadprogress = 0;
                    this.uploading = true;
                    try {
                        const { data } = await axios.post("/backend/creator/upload.php", createFormData(this.form), {
                            onUploadProgress: (e) => {
                                this.uploadprogress = (e.loaded / e.total * 100 | 0);
                            }
                        });
                        this.fileList = [];
                        if (data.code == 0) {
                            this.$message.success("发布成功");
                            this.$refs.form.resetFields();
                        } else {
                            this.$error({
                                title: '发布失败',
                                width: '85%',
                                content: h => (<pre class="message">{ data.message }</pre>),
                            });
                        }
                    } catch (e) {
                        this.$message.error(`发布成功: ${ e }`);
                    } finally {
                        this.uploading = false;
                    }
                }
            });
        },
    },
    watch: {
        title(newvalue, oldvalue) {
            document.title = `${ newvalue } - 后台 - HTML5魔塔广场`;
        }
    },
    components: {
        MainHeader, Footer, Title,
    },
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.list-container {
    font-size: 18px;
    .ant-list-item {
        background: #f1f1f1;
    }
}
.tower-list {
    margin: 0 20px;
    .tower-item {
        display: flex;
        padding: 0px;
        margin-bottom: 12px;
        height: 58.6px;
        .tower-info {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-grow: 1;
            color: inherit;
            &-title {
                margin-right: 10px;
            }
            &-name {
                font-size: 16px;
                color: rgba(0,0,0,0.35);
            }
        }
        .tower-label {
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.upload-tower-button {
    cursor: pointer;
}
.upload-form {
    max-width: 600px;
}
</style>

<style lang="less">
.upload-dialog .ant-modal {
    max-width: 800px;
}
.render-text {
    font-size: 16px;
    text-align: left;
    color: #444444;
    img {
        max-width: 100%;
    }
    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
        p {
            margin: 10px 0;
            line-height: 1.5;
        }
    }
    overflow-wrap: anywhere;
}
</style>
